import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "bootstrap/dist/css/bootstrap.css";
import "jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import '../../assets/css/style.css';
import 'popper.js';

import Logo from '../../assets/img/logo_one_color_white.png';
import ProfileBlock from '../shared/ProfileBlock.jsx';

class Header extends React.Component {
    render() {
        return (
            <header>
                <nav className="navbar navbar-expand-lg navbar-light justify-content-between">
                    <a className="navbar-brand align-bottom title" href="/">
                        <img src={Logo} className="d-inline-block logo mr-2" alt="" />
                        IMMS
                    </a>
                    {/* <ul className="navbar-nav"> */}
                        {/* <li className="nav-item">
                            <a className="nav-link" href="/settings" title="Настройки"><FontAwesomeIcon icon="cog" size="lg" color="#eee" /></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/settings" title="Уведомления"><FontAwesomeIcon icon="bell" size="lg" color="#eee" /></a>
                        </li> */}
                        
                        <ProfileBlock />
                        
                        {/* <li className="nav-item dropdown ml-5">
                            <a className="nav-link dropdown-toggle" href="#" id="userActionsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className = "text-white mr-2">Alexander</span>
                                <FontAwesomeIcon icon="user" size="lg" color="#eee" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userActionsDropdown">
                                <a className="dropdown-item" href="/users/profile">Профиль</a>
                                <a className="dropdown-item" href="/users/logout">Выход</a>
                            </div>
                        </li> */}
                    {/* </ul> */}
                </nav>
            </header>
        );
    }
}

export default Header;